import React from "react"
import ComponentError from "components/component-error"

/**
 * Missing Component is rendered when a CMS component cannot be found on the frontend
 * (Since it is imported from HOC folder imports from folder indexs won't resolve. Hence /configured-radium)
 */
const MissingComponent = ({ expectedComponentName }) => (
  <ComponentError>{expectedComponentName || "Component"} not found</ComponentError>
)

export default MissingComponent



// WEBPACK FOOTER //
// ./src/components/missing-component/index.jsx